// Module 09 §8 — the per-navigation dashboard reset, contributed to 05's `registerNavReset`.
//
// Ports v3 `router/index.js:51`, where `dashboardStore.clearDashboardWs()` was the first
// statement of a mega-`beforeEach` that reached into four feature stores. Navigation must not
// know this feature exists, so the direction inverts: 09 hands 05 a callback and 05 runs it
// (contract 05 §4). 09 never imports `app/` — the shell calls this at boot with its own
// `registerNavReset`, which is also why the register function is a parameter, not an import.
import { useDashboardStore } from '../stores/dashboardStore'

export type NavResetRegister = (reset: () => void) => void

/**
 * The store is resolved INSIDE the callback, not at registration time: the shell registers
 * during boot composition, and resolving a Pinia store then would bind to whatever the active
 * instance was at that moment (and throw outright if none is active yet).
 */
export function registerDashboardNavReset(register: NavResetRegister): void {
  register(() => {
    useDashboardStore().clearDashboardWs()
  })
}
